<template>
  <w-setting-sliding-popup v-loading="isLoading" ref="slidingPopup" title="데이터베이스 수동 등록" width="500px" @close="close" @open="open">
    <div slot="content">
      <el-form :model="databaseFormData" label-position="top" ref="databaseForm" :rules="rules">
        <div class="title-h4 title-bar">기본 정보</div>
        <div class="mr-b25">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="DB명" prop="objName">
                <el-input v-model="databaseFormData.objName" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="DB 종류" prop="objtypeId">
                <el-select v-model="databaseFormData.objtypeId" style="width:100%" @change="onObjtypeChange">
                  <el-option v-for="item in dbtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="DB 버전" prop="objProductId">
                <el-select v-model="databaseFormData.objProductId" style="width:100%">
                  <el-option v-for="item in objProductList" :key="item.objProductId" :label="item.objProductId" :value="item.objProductId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="mr-b25">
          <div class="title-h4 title-bar">DB 접속정보</div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="IP 타입" prop="ipaddressApplytype">
                <el-select v-model="databaseFormData.ipaddressApplytype" style="width:100%">
                  <el-option v-for="item in iptypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="IP 주소" prop="dbmsIpaddress">
                <el-input v-model="databaseFormData.dbmsIpaddress" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item v-if="databaseFormData.objtypeId == 'CUBRID'" label="운영체제" prop="dbmsAgentOs">
                <el-select v-model="databaseFormData.dbmsAgentOs" style="width:100%">
                  <el-option v-for="item in agentOsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-else label="포트번호" prop="dbmsPort">
                <el-input v-model="databaseFormData.dbmsPort" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="databaseFormData.objtypeId == 'CUBRID'">
            <el-col :span="12">
              <el-form-item label="브로커 포트번호" prop="dbmsBrokerPort">
                <el-input v-model="databaseFormData.dbmsBrokerPort" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="에이전트 포트번호" prop="dbmsAgentPort">
                <el-input v-model="databaseFormData.dbmsAgentPort" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="SID" prop="dbmsService">
                <el-input v-model="databaseFormData.dbmsService" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="서비스명" prop="dbmsAlias">
                <el-input v-model="databaseFormData.dbmsAlias" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="DB 접속 아이디" prop="dbmsUserid">
                <el-input v-model="databaseFormData.dbmsUserid" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="DB 접속 비밀번호" prop="dbmsUserpw">
                <el-input type="password" v-model="databaseFormData.dbmsUserpw" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <div class="title-h4 title-bar">DB 세션 제한</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="세션 최대 개수" prop="dbmsSessionMaxCount">
                <el-input-number v-model="databaseFormData.dbmsSessionMaxCount" controls-position="right" :min="0" placeholder="입력해 주세요." style="width:100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Lock 최대 개수" prop="dbmsLockMaxCount">
                <el-input-number v-model="databaseFormData.dbmsLockMaxCount" controls-position="right" :min="0" placeholder="입력해 주세요." style="width:100%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="primary" @click="connectionDbTest">DB 접속 테스트</el-button>
      <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
      <el-button size="large" @click="clickCancelButton">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, cloneDeep, findIndex, isEqual, isEmpty, assign } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import ObjProductAPI from '@/api/model/obj-product';
import objtypeApi from '@/api/model/objtype';
import DeviceRegistrationDbmsAPI from '@/api/settings/common/device-registration-dbms';

export default {
  name: 'WAddDatabasePopup',
  watch: {
    'databaseFormData.objtypeId': {
      handler(value) {
        if (!isNil(value)) {
          ObjProductAPI.getObjProductList(value).then((response) => {
            this.objProductList = cloneDeep(response.data.data);
            this.databaseFormData.objProductId = this.objProductList[0].objProductId;
            this.databaseFormData.objCompanyId = this.objProductList[0].objCompanyId;
          });
        }
      },
    },
  },
  data() {
    return {
      isLoading: false,
      databaseFormData: {
        objName: null,
        dbmsIpaddress: null,
        dbmsAlias: null,
        objManagementApplyFlag: false,
        objtypeId: null,
        objProductId: null,
        ipaddressApplytype: null,
        dbmsSessionMaxCount: null,
        dbmsLockMaxCount: null,
        dbmsService: null,
        dbmsUserpw: null,
        dbmsUserid: null,
        dbmsBrokerPort: 33000,
        dbmsPort: null,
        dbmsAgentPort: null,
        dbmsAgentOs: 'WINDOWS',
      },
      rules: {
        objName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        objtypeId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        objProductId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        ipaddressApplytype: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsIpaddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        dbmsPort: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsAgentOs: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsBrokerPort: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsAgentPort: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsService: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsUserid: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsUserpw: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        dbmsLockMaxCount: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      objProductList: [],
      iptypeList: [],
      dbtypeList: [],
      agentOsList: [
        {
          id: 'WINDOWS',
          name: 'WINDOWS',
        },
        {
          id: 'LINUX',
          name: 'LINUX',
        },
      ],
    };
  },
  methods: {
    loadData() {},
    open() {
      DeviceRegistrationDbmsAPI.getDbPortList().then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          this.dbPortList = response.data.data;
        }
        objtypeApi.getProviedObjtypeList('DBMS').then((typeRes) => {
          this.dbtypeList = isEmpty(typeRes.data.data) ? [] : typeRes.data.data;
          this.databaseFormData.objtypeId = this.dbtypeList[0].objtypeId;
          this.setDefaultDbPort(this.databaseFormData.objtypeId);
        });
      });
      BasicinfoSubAPI.getList('IPTYPE').then((response) => {
        this.iptypeList = cloneDeep(response.data.data);
        this.databaseFormData.ipaddressApplytype = this.iptypeList[0].basicinfoSubid;
      });
    },
    close() {
      this.$refs.databaseForm.resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * DB 종류에 맞는 기본 포트를 설정한다.
     * @author Ju
     * @param  {[type]} dbType [description]
     */
    setDefaultDbPort(dbType) {
      const index = findIndex(this.dbPortList, (item) => item.basicinfoSubid === dbType);
      if (index >= 0) {
        const port = this.dbPortList[index].basicinfoSubvalueInteger;
        if (dbType === 'CUBRID') {
          this.databaseFormData.dbmsBrokerPort = port;
        } else {
          this.databaseFormData.dbmsPort = port;
        }
      }
    },
    clickSaveButton() {
      const objtypeId = this.databaseFormData.objtypeId;
      if (isEqual(objtypeId, 'CUBRID')) {
        this.databaseFormData.dbmsPort = this.databaseFormData.dbmsBrokerPort;
      } else {
        this.databaseFormData.dbmsAgentOs = 'WINDOW';
      }
      this.$refs.databaseForm.validate().then((res) => {
        if (res) {
          const target = '데이터베이스';
          const action = msgUtil.action.REGIST;
          const encryptTargetData = createEncryptTargetData(this.databaseFormData, ['dbmsUserpw']);
          getRsaEncrypt(encryptTargetData)
            .then((encryptData) => {
              this.isLoading = true;
              DeviceRegistrationDbmsAPI.insertDatabase(assign(cloneDeep(this.databaseFormData), encryptData))
                .then((response) => {
                  const result = response.data;
                  if (result.success === true) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.$emit('re-load');
                    this.closePopup();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                })
                .finally(() => {
                  this.isLoading = false;
                });
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        }
      });
    },
    clickCancelButton() {
      this.closePopup();
    },
    connectionDbTest() {
      if (this.databaseFormData.objtypeId === 'CUBRID') {
        this.databaseFormData.dbmsPort = this.databaseFormData.dbmsBrokerPort;
      }

      this.$refs.databaseForm.validate().then((success) => {
        if (success) {
          const encryptTargetData = createEncryptTargetData(this.databaseFormData, ['dbmsUserpw']);
          getRsaEncrypt(encryptTargetData)
            .then((encryptData) => {
              DeviceRegistrationDbmsAPI.connectionDbTest(assign(cloneDeep(this.databaseFormData), encryptData))
                .then((response) => {
                  if (response.data.success) {
                    this.$message(msgUtil.getCustomResultMsgData(response.data.data, true));
                  } else {
                    this.$message(msgUtil.getCustomResultMsgData('DB 연결에 실패하였습니다.', false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getCustomResultMsgData('DB 연결에 실패하였습니다.', false));
                });
            })
            .catch((e) => {
              this.$message(msgUtil.getCustomResultMsgData('DB 연결에 실패하였습니다.', false));
              throw new Error(e);
            });
        }
      });
    },
    validateIpaddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else if (this.databaseFormData.ipaddressApplytype === 'IPv4') {
        if (validateIpv4(value)) {
          callback();
        } else {
          callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
        }
      } else {
        /* eslint-disable no-lonely-if */
        if (validateIpv6(value)) {
          callback();
        } else {
          callback(new Error('올바른 IPv6 주소형식을 입력해주세요'));
        }
        /* eslint-enable no-lonely-if */
      }
    },
    onObjtypeChange(val) {
      this.setDefaultDbPort(val);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Database/popup/AddDatabasePopup.vue